const getters = {
  /**
   * Get current Application Name
   * @param state
   * @returns {String|string}
   */
  appName: state => (state.application ? state.application.name : ""),

  /**
   * Get current Application Icon
   * @param state
   * @returns {String|string}
   */
  appIcon: state => (state.application ? state.application.icon : ""),

  /**
   * Get current Application Title
   * @param state
   * @returns {String|string}
   */
  appTitle: state => (state.application ? state.application.title : ""),

  /**
   * Is visible Left Drawer
   * @param state
   * @returns {boolean}
   */
  visibleLeftDrawer: state => state.drawerLeft,

  /**
   * Is visible Right Drawer
   * @param state
   * @returns {boolean}
   */
  visibleRightDrawer: state => state.drawerRight,

  /**
   * Is visible Jump command
   * @param state
   * @returns {boolean}
   */
  visibleJump: state => state.visibleJump,

  /**
   * Is visible Options command
   * @param state
   * @returns {boolean}
   */
  visibleOptions: state => state.visibleOptions,

  /**
   * Uses Tabs as a Application selector
   * @param state
   * @returns {boolean}
   */
  usesAppTabs: state => state.usesAppTabs,

  /**
   * Uses Modal Jump Dialog as a module selector
   * @param state
   * @returns {boolean}
   */
  usesModalDialogJump: state => state.usesModalDialogJump,

  /**
   * Uses Sidebar Image
   * @param state
   * @returns {boolean}
   */
  usesSidebarImage: state => state.usesSidebarImage,

  /**
   * Get dialog Toolbar Style
   * @param state
   * @returns {boolean}
   */
  dialogToolbarStyle: state => state.dialogToolbarStyle,

  /**
   * Get Dialog Title Text Color
   * @param state
   * @returns {{name: string, variantType: string, variantNumber: number}}
   */
  dialogTitleColor: state => state.dialogTitleColor,

  /**
   * Application Bar Material Design Color
   * @param state
   * @returns {{name: String, variantType: String, variantNumber: Number}}
   */
  appBarColor: state => state.appBarColor,

  /**
   * Data Table Toolbar Material Design Color
   * @param state
   * @returns {{variantType: string, variantNumber: number, name: string}}
   */
  dataTableToolbarColor: state => state.dataTableToolbarColor,

  /**
   * Get Menu Item colorName
   * @param state
   * @returns {{name:String, variantType:String, variantNumber:Number}}
   */
  menuItemColor: state => state.menuItemColor,

  /**
   * Get progress Color
   * @param state
   * @returns {{name:String, variantType:String, variantNumber:Number}}
   */
  progressColor: state => state.progressColor,

  /**
   * Get Button Color
   * @param state
   * @returns {{variantType: string, variantNumber: number, name: string}}
   */
  buttonColor: state => state.buttonColor,

  /**
   * Get Cancel Button Color
   * @param state
   * @returns {{variantType: undefined, variantNumber: undefined, name: string}}
   */
  buttonCancelColor: state => state.buttonCancelColor,

  /**
   * Get command Buttons Text Style
   * @param state
   * @returns {boolean}
   */
  buttonTextStyle: state => state.buttonTextStyle,

  /**
   * Get whether button is Outlined
   * @param state
   * @returns {boolean}
   */
  buttonOutlined: state => state.buttonOutlined,

  /**
   *  Details Toolbar colors
   *  Note: implements Material Material Design Color
   * @param state
   * @returns {{name:String, variantType:String, variantNumber:Number}}
   */
  detailsToolbarColor: state => state.detailsToolbarColor,

  /**
   * Delete Color
   * Note: implements Material Material Design Color
   * @param state
   * @returns {{name: String, variantType: String, variantNumber: Number}}
   */
  deleteColor: state => state.deleteColor
};

export default getters;
